<script>
	import { styles } from '../scripts/styles'
	export let column = '100%'
	export let backgroundColor = 'transparent'
	export let alignHorizontal = 'center'
	export let alignVertical = 'center'
	export let padding = '0%'
</script>

<!-- one column layout  -->
<div use:styles={{ column, backgroundColor, padding, alignHorizontal, alignVertical }} class="container">
	<slot name="column1" />
</div>

<style>
	.container {
		display: flex;
		width: var(--column);
		justify-content: var(--alignHorizontal);
		align-items: var(--alignVertical);
		padding: var(--padding);
		background-color: var(--backgroundColor);
	}
</style>
